module.exports = "<div class=\"instructions-container\">\n    <div class=\"instruction add-retailer\">\n        {{currentInstruction}} <a (click)=\"closeAddRetailerFlow()\" class=\"action border\"><i class=\"material-icons\">close</i> Cancel</a>\n    </div>\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/maps-add-stuff/components/add-retailer/add-retailer.component.html
// module id = ./src/app/modules/maps-add-stuff/components/add-retailer/add-retailer.component.html
// module chunks = main